import axios from "axios";

const { REACT_APP_VEHICLES_API } = process.env;

export const getVehicleTemplates = async (customer) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles/templates`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response?.data };
  }
};

export const getVehicleTemplate = async (customer, templateId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles/templates/${templateId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const createVehicleTemplate = async (
  customer,
  name,
  description,
  allColumns,
  defaultColumns,
  isDigital,
  ignitionValue,
  isDefaultTemplate,
) => {
  try {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("token"))
      ?.split("=")[1];
    const res = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles/templates`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        name,
        description,
        all_columns: allColumns,
        default_columns: defaultColumns,
        is_digital: isDigital,
        ignition_value: ignitionValue,
        is_default_template: isDefaultTemplate,
      },
    });
    return { data: res.data };
  } catch (e) {
    let details = e.response?.data?.details;
    if (!details) {
      details = Object.values(e.response.data.errors[0]).join("\n");
    }
    throw new Error(details);
  }
};

export const updateVehicleTemplate = async (
  customer,
  templateId,
  name,
  description,
  allColumns,
  defaultColumns,
  isDigital,
  ignitionValue,
  isDefaultTemplate,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "put",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles/templates/${templateId}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        name,
        description,
        all_columns: allColumns,
        default_columns: defaultColumns,
        is_digital: isDigital,
        ignition_value: ignitionValue,
        is_default_template: isDefaultTemplate,
      },
    });
    return { data: res.data };
  } catch (e) {
    let details = e.response?.data?.details;
    if (!details) {
      details = Object.values(e.response.data.errors[0]).join("\n");
    }
    throw new Error(details);
  }
};

export const getVehicleTemplateParameters = async () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/templates/parameters`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const createVehicleTemplateParameter = async (parameter) => {
  try {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("token"))
      ?.split("=")[1];
    const res = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/templates/parameters`,
      headers: { Authorization: `Bearer ${token}` },
      data: { parameter },
    });
    return {
      data: res.data,
    };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const deleteParameter = async (parameterId) => {
  try {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("token"))
      ?.split("=")[1];
    const response = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/templates/parameters/${parameterId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const deleteVehicleTemplate = async (customer, id) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicles/templates/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response.data };
  } catch (e) {
    return { detail: e.response?.data };
  }
};
